import Labels from "common/components/Labels";
import useLeadLabelsMutations from "common/datahooks/useLeadLabelsMutations";
import type { Label } from "common/types";

interface LeadLabelsProps {
  labels: Label[];
  profileId: string;
  align: "center" | "end" | "start";
  size?: "md" | "sm";
  maxLabels?: number;
}

export default function LeadLabels({
  labels,
  profileId,
  align,
  size = "md",
  maxLabels = Infinity,
}: LeadLabelsProps) {
  const { removeLeadLabel, addLeadLabel } = useLeadLabelsMutations();

  function onAddLabel(label: Label) {
    return addLeadLabel({ label, profileId });
  }
  function onRemoveLabel(label: Label) {
    removeLeadLabel({ label, profileId });
  }

  return (
    <Labels
      labels={labels}
      onAddLabel={onAddLabel}
      onRemoveLabel={onRemoveLabel}
      align={align}
      size={size}
      maxLabels={maxLabels}
    />
  );
}
